// extracted by mini-css-extract-plugin
module.exports = {"heroSimple":"hero-simple-module--heroSimple--3NmS_"};